import angular from 'angular';
import { transactionTypeMap } from '../constants';
import { sysvarFormCtrl } from './sysvarform/sysvarform.controller.js';
import sysvarFormHtml from './sysvarform/sysvarform.html';

export default angular.module('myComponents', [])
  .component('cgTransactionDescription', {
    template: `
      {{$ctrl.mappedName}}
      <span ng-if="$ctrl.transaction.type==='purchase' || $ctrl.transaction.type==='reversal'">
        - {{$ctrl.transaction.product.productName || $ctrl.transaction.product.description}}
        
        <span ng-if="$ctrl.transaction.member">
          - <cg-member-name member="$ctrl.transaction.member"></cg-member-name>
        </span>

        <span ng-if="$ctrl.transaction.extra">
          - {{$ctrl.transaction.extra.option}}
        </span> 

      </span>

      <span ng-if="($ctrl.transaction.type=='accountTypeAdjustment')">
        - {{$ctrl.transaction.extra.postType}}
      </span>

      <span ng-if="$ctrl.transaction.qty && $ctrl.transaction.qty > 1">
        ({{$ctrl.transaction.qty}})
      </span>
    `,
    bindings: {
      transaction: '<',
    },
    controller: function () {


      this.$onChanges = (changes) => {
        if (changes.transaction) {
          this.mappedName = (this.transaction.reversed ? 'RETURNED ' : '')
            + (transactionTypeMap[this.transaction.type] || 'Unknown Type');
        }
      }
    },
  })
  .component('cgTransactionAmount', {
    template: `
      <span ng-if="$ctrl.transaction.amount>=0">\${{$ctrl.transaction.amount}}</span>
      <span ng-if="$ctrl.transaction.amount<0">(\${{-$ctrl.transaction.amount}})</span>
    `,
    bindings: {
      transaction: '<',
    }
  })
  .component('cgMemberName', {
    template: `
      <span ng-if='!$ctrl.format'>{{$ctrl.member.commonName || $ctrl.member.firstName}} {{$ctrl.member.lastName}}</span>
      <span ng-if='$ctrl.format==="lastfirst"'>{{$ctrl.member.lastName}}, {{$ctrl.member.commonName || $ctrl.member.firstName}} </span>
      <span ng-if='$ctrl.format==="short"'>{{$ctrl.member.commonName || $ctrl.member.firstName}}</span>
      <span ng-if='$ctrl.format==="long"'>
        {{$ctrl.member.firstName}}
        <span ng-if='$ctrl.member.commonName'>({{$ctrl.member.commonName}})</span>
        {{$ctrl.member.lastName}}
      </span>
    `,
    bindings: {
      member: '<',
      format: '@',
    },
  })
  .component('cgMemberSelectBox', {
    template: `
      <div class="member-select-box">
        <cg-member-name member="$ctrl.member" format="short"></cg-member-name>
        <div class="member-select" ng-class="{'member-select-black': $ctrl.member.selected}">
        </div>
      </div>
    `,
    bindings: {
      member: '<',
      selected: '<'
    }
  })
  .component('sysvarform', {
    template: sysvarFormHtml,
    transclude: true,
    controller: sysvarFormCtrl,
    bindings: {
      sysvars: '<',
      heading: '<',
      multi: '<',
      onSelection: '<',
      onSave: '<',
      onCancel: '<',
      setFormHooks: '<'
    }
  });
